import { EntityType } from './entityTypes';

export const AddlFieldType = {
	NUM: 'NUM',
	STR: 'STR',
	TEXT: 'TEXT',
	DATE: 'DATE',
	TAG: 'TAG',
	DATETIME: 'DATETIME',
	BOOL: 'BOOL',
	SELECT: 'SELECT',
	SELECT_MULTI: 'SELECT_MULTI',
	HYPERLINK: 'HYPERLINK',
	OBJECT_RELATION: 'OBJECT_RELATION',
	OBJECT_RELATION_MULTI: 'OBJECT_RELATION_MULTI',
	RICH_TEXT: 'RICH_TEXT',
	DUMMY: 'DUMMY',
};

export const AddlSelectEntityReference = {
	[EntityType.CONTACT]: 'CONTACT',
	[EntityType.USER]: 'USER',
};

// These are fields that use react-select under the hood.
export const SelectBasedFields = [
	AddlFieldType.TAG,
	AddlFieldType.SELECT,
	AddlFieldType.SELECT_MULTI,
	AddlFieldType.OBJECT_RELATION,
	AddlFieldType.OBJECT_RELATION_MULTI,
];

export const MultiFields = [
	AddlFieldType.SELECT_MULTI,
	AddlFieldType.OBJECT_RELATION_MULTI,
];

export const ReadOnlyFieldsByEntity = {
	[EntityType.CONTACT]: ['email'],
	[EntityType.CUSTOMER]: ['qbd_id', 'qbd_edit_sequence', 'qbd_last_synced', 'qbd_response_log'],
};

export const TagFieldNames = {
	TAGS: 'tags',
	EMAIL_TO: 'email_to',
	SUBMITTED_BY: 'submitted_by',
};

export const ColumnSort = {
	DESC: 'desc',
	ASC: 'asc',
};

export const NUMBER_OF_COLUMNS_FOR_SAMPLE = 6;
export const NUMBER_OF_COLUMNS_FOR_SAMPLE_MOBILE = 2;
export const NUMBER_OF_COLUMNS_FOR_TEST = 5;
export const NUMBER_OF_COLUMNS_FOR_ASSAY = 5;

export const NUMBER_OF_CUSTOM_COLUMNS_ORDER_ADDITIONAL_INFO = 4;
export const NUMBER_OF_CUSTOM_COLUMNS_ORDER_ADDITIONAL_INFO_MOBILE = 2;
export const NUMBER_OF_ORDERS_FIELDS = 8;

export const NUMBER_OF_CUSTOM_COLUMNS_SAMPLE_ADDITIONAL_INFO = 4;
export const NUMBER_OF_SAMPLES_FIELDS = 8;

export const ENABLED_MODULES = {
	BILLING: 'BILLING_ENABLED',
	TURNAROUNDS: 'TURNAROUNDS_ENABLED',
	EDD: 'EDD_ENABLED',
	SOURCES: 'SOURCES_ENABLED',
	PROJECTS: 'TRIALS_ENABLED',
	DIVISIONS: 'DIVISIONS_ENABLED',
};

export const PORTALVIEW_PERMISSION = {
	COMMENT_VIEW: 'COMMENT_VIEW',
	COMMENT_WRITE: 'COMMENT_WRITE',
	PRICING_VIEW: 'DISABLE_PORTAL_PRICING',
	PROJECT_VIEW: 'TRIAL',
	ACCOUNT_CREATE: 'ALLOW_CUSTOMER_SIGNUP',
	ORDER_REQUEST_CREATE: 'ORDER_REQUEST',
	ORDER_REQUEST_CLONE: 'ORDER_REQUEST_CLONE',
	TEST_RECURRENCE_CREATE: 'ORDER_REQUEST_TEST_RECURRENCE',
	TEST_FIELDS_EXPAND: 'ORDER_REQUEST_TEST_AUTO_EXPAND',
	SAMPLE_ASSAY_ENFORCEMENT: 'ORDER_REQUEST_FORCE_SAMPLE_ASSAY_ASSIGNMENT',
	KEEP_OVERRIDDEN_REPORTS: 'keep_overridden_reports_in_portal',
	INDICATE_OVERRIDDEN_REPORTS: 'indicate_override_reports',
};

export const INVOICE_LINE_ITEM_TYPES = {
	INVOICE_ITEM: 'INVOICE_ITEM',
	SUBTOTAL: 'SUBTOTAL',
	FLAT_SURCHARGE: 'FLAT_SURCHARGE',
	FLAT_DISCOUNT: 'FLAT_DISCOUNT',
	PERCENT_SURCHARGE: 'PERCENT_SURCHARGE',
	PERCENT_DISCOUNT: 'PERCENT_DISCOUNT',
	TOTAL: 'TOTAL', // Note: This type doesn't exist on the LIMS
};

export const SETTINGS = {
	FILTER_TAT_BY_ASSAY_ENABLED: 'FILTER_TAT_BY_ASSAY_ENABLED'
};
